import script from "./HrConfirmDestructiveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrConfirmDestructiveDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrConfirmDestructiveDialog.vue?vue&type=style&index=0&id=944de11e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-944de11e"]])

export default __exports__